var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUpload = function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M3.893 13.429c-1.598 0-2.893-1-2.893-2.466C1 9.497 2.295 8.31 3.893 8.31c.109 0 .216.005.321.016v-.016h.04a4.378 4.378 0 0 1-.04-.59C4.214 5.113 6.517 3 9.357 3c1.924 0 3.6.969 4.482 2.404.216-.03.437-.045.661-.045 2.485 0 4.5 1.85 4.5 4.13 0 1.877-1.365 3.308-3.234 3.78M9.858 17v-6.774m0 0L6.906 13.02m2.952-2.794 2.954 2.794"
  })));
};
export default SvgFileUpload;